export const LICENCES_COUNT_REQUEST = 'LICENCES_COUNT_REQUEST';
export const LICENCES_COUNT_SUCCESS = 'LICENCES_COUNT_SUCCESS';
export const LICENCES_COUNT_ERROR = 'LICENCES_COUNT_ERROR';
export const LICENCES_COUNT_TOKEN = 'LICENCES_COUNT_TOKEN';
